import * as React from 'react';

import Box from '@mui/material/Box';
import SpeedDial from '@mui/material/SpeedDial';
import Avatar from '@mui/material/Avatar';

import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import SellIcon from '@mui/icons-material/Sell';
import BalanceIcon from '@mui/icons-material/Balance';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

export default function ReimoSpeedDial(props) {
  	

	return (<>
				<Box
			          role="presentation"
			          sx={{
			            position: "fixed",
			            bottom: 0,
			            right: 0,
			            zIndex: 10000,
			            bgcolor: 'ochre.main'
			          }}
			        >
				    <Box sx={{ height: 320, transform: 'translateZ(0px)', flexGrow: 1 }}>
				      <SpeedDial
				        ariaLabel="Reimo"
				        sx={{ position: 'absolute', bottom: 16, right: 16, }}
				        FabProps={{ sx: {
								      bgcolor: '#163e64',
								      '&:hover': {
								        bgcolor: '#163e64',
								      }
								    }
								  }}
				        icon={<SpeedDialIcon />}
				      >
				          <SpeedDialAction
				            key={"mmm"}
				            tooltipTitle="Verwaltung"
				                  icon={
							        <Avatar sx={{ border: "1px solid #163e64"}} > <ManageAccountsIcon />
							        </Avatar>
							  }
							
				          >
				          </SpeedDialAction>
				          <SpeedDialAction
				            key={"mmm"}
				            tooltipTitle="Verkauf"
				                  icon={
							        <Avatar sx={{ border: "1px solid #163e64"}} > <SellIcon />
							        </Avatar>
							  }
				          >
				          </SpeedDialAction>
				          <SpeedDialAction
				            key={"mmm"}
				            onClick={e => props.setChatStatus(true)}
				            tooltipTitle="Bewertung"
			        	    FabProps={{ sx: {
						      bgcolor: '#ff0000',
						      '&:hover': {
						        bgcolor: '#ff0000',
						      }
						    }
						  }}				            
				                  icon={
							        <Avatar sx={{ border: "1px solid #163e64"}} ><BalanceIcon />
							        </Avatar>
							  }
				          >
				          </SpeedDialAction>
			

				      </SpeedDial>
				      
				    </Box>
			    </Box>
			</>
		  );
}